import { render, staticRenderFns } from "./Ec2MachineCard.vue?vue&type=template&id=99ded87c&scoped=true"
import script from "./Ec2MachineCard.vue?vue&type=script&lang=js"
export * from "./Ec2MachineCard.vue?vue&type=script&lang=js"
import style0 from "./Ec2MachineCard.vue?vue&type=style&index=0&id=99ded87c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ded87c",
  null
  
)

export default component.exports